<script>
import { BIconArrowLeft, BIconEnvelope, BIconEye, BIconEyeFill  } from 'bootstrap-vue';
import { validationMixin } from 'vuelidate';
import { required, email, sameAs, minLength,requiredIf } from 'vuelidate/lib/validators';
import firebase from 'firebase/app';
import * as fb from '../firebase';
import { auth,customersCollection,agreementsCollection,usersCollection,firebaseApp,db } from '../firebase';
import { clioLogin } from '../clioIntegration';
import clientUserFormHelper from '@/mixins/clientUserFormHelper';
import allProvinces from 'provinces';
import filter from 'lodash/filter';
import { mapState } from 'vuex';
import toastMessage from '@/mixins/toast';
import emailApiRequest from '@/lib/emailApiRequest';
import { addDays } from 'date-fns';
import { markSignupInProgress, clearSignupInProgress } from '@/lib/signupSession';

export default {
    props: {
        userType: {
        type: String,
        default: 'lawyer',
        },
    },
    components: {
        BIconArrowLeft,
        BIconEnvelope,
        BIconEye,
        BIconEyeFill
    },
    mixins: [validationMixin, clientUserFormHelper,toastMessage],
    data() {
        return {
            //currentSignUpPage: null,
            // currentLoginPage: null,
            currentRole: null,
            activeTab: null,
            connectClio: null,
            forgotPassword: false,
            highestLoginPageVisited:1,
            highestSignupPageVisited:1,
            clientDetails: {
                firstName: '',
                lastName: '',
                organizationName: '',
                // locationOfPractice: 'British Columbia', /* Release 2.2 */
                 locationOfPractice: '',
                email: '',
                // phoneNumber: '',
                password: '',
                termsOfService:false,
                marketingConsent:false
            },
            loginDetails: {
                email: '',
                password: ''
            },
            resetEmail:null,
            loginError: null,
            loginLoading:false,
            signupError:null,
            signUpLoading:false,
            resetPasswordError: null,
            resetPasswordLoading: false,
            resetEmailSent: false,
            showPassword: false,
            authProvider : '',
            userSnap:'',
            emailDisabled:false,
            avoidPassword:false,
            isUserExists:false,
            signupUserId:'',
            agreementId:'',
            invitedRoleLevel: '',
            isGoBackVisible: true,
            accountCreated: false,
            providerBusy: false,
            emailInUse: false,
        };
    },
    validations: {
        clientDetails: {
            firstName: {
                required,
            },
            lastName: {
                required,
            },
            email: {
                required,
                email
            },
            // phoneNumber: {
            //     required,
            // },
            password: {
                required:requiredIf(function(){
                    return this.authProvider == 'GOOGLE' ? false: true
                }),
                minLength: minLength(6)
            },
            termsOfService: { required, sameAs: sameAs(() => true) },
            locationOfPractice: {
                required: requiredIf(function () {
                    return this.currentRole !== 'party';
                }),
            },
        },
        loginDetails: {
            email: {
                required,
                email
            },
            password: {
                required
            }
        },
        resetEmail:{
            required,
            email
        }
    },
    mounted() {
        this.setQueryValuesToPage(this.$route.query);
        // if(this.agreementId){
        //     localStorage.setItem('clientUserAgreement', this.agreementId);
        // }else if(localStorage.getItem('clientUserAgreement')){
        //     this.agreementId = localStorage.getItem('clientUserAgreement');
        // }
        if(localStorage.getItem('showGoogleLoginConfirmation') && localStorage.getItem('showGoogleLoginConfirmation') =='true'){
            this.signInWithGoogle();
            setTimeout(()=> {localStorage.removeItem('showGoogleLoginConfirmation')},1000);
        }
        if (this.activeTab === 0) {
            this.changeloginPage(Number(this.$route.query.page) || 1) 
        }
        else if (this.activeTab === 1) {
            this.changeSignUpPage(Number(this.$route.query.page) || 1)
        };
        if(localStorage.getItem('loginProvider')){
            if((localStorage.getItem('loginProvider')=='CLIO' || localStorage.getItem('isClioFetch') == 'true') && localStorage.getItem('clioUser')) {
                this.clientDetails.email =  JSON.parse(localStorage.getItem('clioUser')).email;
                this.loginDetails.email =  JSON.parse(localStorage.getItem('clioUser')).email;
                this.emailDisabled = true;
            } else if(localStorage.getItem('loginProvider')=='GOOGLE'){
                if(auth.currentUser){
                    console.log('auth.currentUser',auth.currentUser)
                    this.clientDetails.email =  auth.currentUser.email;
                    this.clientDetails.firstName =  auth.currentUser.displayName;
                    this.setValuesAfterGoogleSignUp(auth.currentUser.email)
                    this.signupUserId = auth.currentUser.uid;
                }
            }
        } else {
                // TO BE DELETED
            // this.$v.loginDetails.email.$model='client300@mailinator.com'
            // this.$v.loginDetails.password.$model='123456'
        }
        window.addEventListener('pageshow', this.onPageShow);
    },
    computed:{
        Provinces(){
			const provinces = filter(allProvinces, { country: 'CA' });
			// Reverted to all provinces for staging/QA.
			// If BC-only is needed again, uncomment the line below and remove `return provinces`.
			// return provinces.filter((province)=>province.name === "British Columbia")
			return provinces
		},
        ...mapState(['roleLevels','currentSignUpPageNo','currentLoginPageNo']),
        currentSignUpPage() {
            return this.currentSignUpPageNo; 
        },
        showMarketingConsent() {
            return !this.invitedRoleLevel || ['lawyer-level-1','lawyer-level-2','client-level-1','client-level-2'].includes(this.invitedRoleLevel);
        },
        isInvited() {
            return !!this.agreementId;
        },
        showSignupIntro() {
            return this.activeTab === 1 && this.currentSignUpPage !== 3 && !this.isInvited;
        },
        signupSteps() {
            return ['Get started', 'Create account'];
        },
        signupStepIndex() {
            return this.currentSignUpPage === 3 ? 1 : 0;
        },
        signupFormTitle() {
            if (this.isInvited) return 'A few details, then you\'re in';
            if (this.currentRole === 'party') return 'Tell us about you';
            return 'Set up your account';
        },
        signupButtonLabel() {
            return 'Create account';
        },
        signupNextStep() {
            if (this.isInvited) return 'Your shared agreement opens next.';
            return '';
        },
        googleInitial() {
            const name = this.clientDetails.firstName || this.clientDetails.email || '';
            return name.charAt(0).toUpperCase();
        },
        formBusy() {
            return this.signUpLoading || this.loginLoading || this.resetPasswordLoading || this.providerBusy;
        },
        termsName() {
            return this.userType === 'lawyer' ? 'Terms of Service' : 'Terms of Use';
        },
        termsUrl() {
            return this.userType === 'lawyer' ? 'https://www.divii.ca/terms-of-service' : 'https://www.divii.ca/terms-of-use';
        },
        pageTitle() {
            const site = this.userType === 'lawyer' ? 'Divii for Lawyers' : 'Divii';
            let screen = 'Sign up';
            if (this.activeTab === 0 && this.forgotPassword) {
                screen = 'Reset password';
            } else if (this.activeTab === 0 && this.currentLoginPage === 3) {
                screen = 'Log in with email';
            } else if (this.activeTab === 0) {
                screen = 'Log in';
            } else if (this.currentSignUpPage === 3) {
                screen = 'Create account';
            } else if (this.isInvited) {
                screen = 'Accept invite';
            }
            return `${screen} · ${site}`;
        },
        showLoginIntro() {
            return this.activeTab === 0 && this.currentLoginPage !== 3 && !this.forgotPassword;
        },
        currentLoginPage() {
            console.log(this.currentLoginPageNo)
            return this.currentLoginPageNo; 
        },
        roles() {
            return {
                lawyer: {
                    label: 'Lawyer',
                    key: 'lawyer',
                    icon: require('@/assets/Divii-Lawyers-Primary.png'),
                    width: '70%'
                },
                party: {
                    label: 'Separating Party',
                    key: 'separating-party',
                    icon: require('@/assets/Divii-Logo-Primary-Colour.png'),
                    width: '60%'
                },
                assistant: {
                    label: 'Assistant',
                    key: 'assistant',
                    icon: require('@/assets/assistant.png'),
                    width: '70%'
                }
            }
        }
    },
    methods: {
        changeRole(role) {
            this.currentRole = role;
            this.$router.replace({
                query: { ...this.$route.query, role: role },
            }).catch(() => {});

        },
        changeTab(event,selectedTab) {
            return new Promise(async resolve => {
            // Track drop-off if switching tabs (e.g., from signup to login)
            if (this.activeTab !== selectedTab) {
                const eventName = this.activeTab === 0 ? 'login_tab_dropoff' : 'signup_tab_dropoff';
                this.$posthog.capture(eventName, {
                    current_tab: this.activeTab === 0 ? 'login' : 'signup',
                    next_tab: selectedTab === 0 ? 'login' : 'signup',
                    current_step: this.activeTab === 0 ? this.currentLoginPage : this.currentSignUpPage,
                    user_id: this.userSnap?.user?.uid || this.signupUserId || null,
                    role: this.$store.state.posthogRole || '',
                    auth_provider: this.authProvider || 'unknown',
                    timestamp: new Date().toISOString(),
                });
            }

            if(selectedTab === 0){
                // this.currentLoginPage = 1
                // this.$route.query.page = 1
                this.changeloginPage(1);
                this.loginError=''
            }
            if(selectedTab === 1){
                // this.currentSignUpPage = 1
                // this.$route.query.page = 1
                this.changeSignUpPage(selectedTab)
            }
            // if(changeInAuth !=null && changeInAuth!=undefined){
            //     this.$route.query.auth = changeInAuth;
            // }
            console.log('selectedTab -> ',selectedTab)
            
            this.$store.dispatch('clearConditionalStorageValues');
            this.resetSignUpForm();
            let queryData = { auth: selectedTab,page:1 };
            if(this.$route.query.id)
                queryData = { auth: selectedTab,page:1 ,id:this.$route.query.id}
            resolve(this.$router.push({
                query: queryData,
            }).catch(() => {}));
            })

        },
        validateState(name, mode) {
            if(mode === 'forgotPassword'){
                const { $dirty, $error } = this.$v["resetEmail"];
                return $dirty ? !$error : null;  
            }
            if (mode === 'login') {
                const { $dirty, $error } = this.$v.loginDetails[name];
                return $dirty ? !$error : null;
            }
            else {
                const { $dirty, $error } = this.$v.clientDetails[name];
                return $dirty ? !$error : null;
            }
        },
        changeSignUpPage(page) {
            console.log('this.currentSignUpPage->',this.currentSignUpPage , 'page->',page,'this.$route.query->',this.$route.query)
            if (this.currentSignUpPage !== page) {
                window.scrollTo(0, 0);
                if (this.currentSignUpPage > page) {
                    this.$posthog.capture('signup_step_dropoff', {
                    step: this.currentSignUpPage,
                    next_step: page,
                    auth_provider: this.authProvider || 'unknown',
                    timestamp: new Date().toISOString(),
                });
                }
                // this.currentSignUpPage = page;
                this.changeSignUpPageAction(page);
                if (page > this.highestSignupPageVisited) {
                    this.highestSignupPageVisited = page;
                    // Track signup step completed
                    this.$posthog.capture('signup_step_completed', {
                        step: page,
                        user_id: this.userSnap?.user?.uid || this.signupUserId || null,
                        role: this.$store.state.posthogRole || '',
                        auth_provider: this.authProvider || 'unknown',
                    });
                }
                
                if(this.$route.query.page != page){
                    this.setStaticQueryDataToRouter(page);
                }
                if(page === 2){
                    this.isUserExists = false;
                } 
            }
        },
        changeSignUpPageAction(page){
            this.setStaticQueryDataToRouter(page);
            this.$store.dispatch('setCurrentSignUpPageAction',page);
        },
        changeloginPage(page) {  
            console.log('page',page)
            if (this.forgotPassword) {
                this.forgotPassword = false;
                this.setStaticQueryDataToRouter(page);
            }
            if (this.currentLoginPage !== page) {
                // this.currentLoginPage = page;
                // Track drop-off if navigating backward
                if (this.currentLoginPage > page) {
                    this.$posthog.capture('login_step_dropoff', {
                        step: this.currentLoginPage,
                        next_step: page,
                        auth_provider: this.authProvider || 'unknown',
                        timestamp: new Date().toISOString(),
                    });
                }
                this.changeloginPageAction(page);
                if (page > this.highestLoginPageVisited) {
                    this.highestLoginPageVisited = page;
                    // Track login step completed
                    this.$posthog.capture('login_step_completed', {
                        step: page,
                        auth_provider: this.authProvider || 'unknown',
                        timestamp: new Date().toISOString(),
                    });
                }
                // if(this.$route.query.page != page){
                    this.setStaticQueryDataToRouter(page);
                }
                // }   
        },
        changeloginPageAction(page){
            this.setStaticQueryDataToRouter(page);
            this.$store.dispatch('setCurrentLoginPageAction',page);
        },
        setStaticQueryDataToRouter(page){
            let queryData = { ...this.$route.query, page: page };
            if(this.$route.query.id){
                queryData = { ...this.$route.query, page: page ,id: this.$route.query.id}
            }
            delete queryData.forgot;
            const isForward = page > (Number(this.$route.query.page) || 1);
            const navigate = isForward ? this.$router.push : this.$router.replace;
            navigate.call(this.$router, {
                query: queryData,
            }).catch(() => {});
        },
        handleClioCheckbox() {
            this.$router.replace({
                query: { ...this.$route.query, clioFetch: this.connectClio },
            }).catch(() => {});

        },
        async signUpWithClio() {
            this.providerBusy = true;
            await this.setAuthProvider('CLIO');
            console.log('routeparam', this.$route.query)
            if(this.$route.query)
                localStorage.setItem('redirectRouteParams',JSON.stringify(this.$route.query))
                clioLogin();
        },
        async signUpWithGoogle() {
            this.providerBusy = true;
            this.setAuthProvider('GOOGLE');
            const provider = new firebase.auth.GoogleAuthProvider();
            provider.setCustomParameters({
                prompt: 'select_account'
            });
            auth.signInWithPopup(provider).then(async (googleResponse)=>{
                markSignupInProgress(googleResponse.user.uid, this.$route.name);
                console.log('googleResponse-->',googleResponse) 
                this.userSnap = googleResponse;
                let userAlreadySignedUp = await this.getCustomerUsingEmail(this.userSnap.additionalUserInfo.profile.email)
                console.log("the user already signedup email,", userAlreadySignedUp);
            if(Object.keys(userAlreadySignedUp).length && userAlreadySignedUp.roleLevel){
                clearSignupInProgress();
                await this.loginExistingGoogleUser();
                return
            }
            else{

                 if( this.userSnap &&  this.userSnap.additionalUserInfo){
                    if(this.userSnap.additionalUserInfo.profile) {
                    this.clientDetails.firstName =  this.userSnap.additionalUserInfo.profile.given_name;
                    this.clientDetails.lastName =  this.userSnap.additionalUserInfo.profile.family_name;
                    this.clientDetails.email =  this.userSnap.additionalUserInfo.profile.email;
                    localStorage.setItem('loggedInEmailID',this.userSnap.additionalUserInfo.profile.email);
                    }
                    this.signupUserId = this.userSnap.user.uid;
                } 
                if(this.currentRole === 'party') {
                    await this.writePartyTrialAndHold(this.signupUserId, false);
                }

                await this.setValuesAfterGoogleSignUp(this.userSnap.additionalUserInfo.profile.email);
                if(this.$route.query.authProvider && this.$route.query.authProvider =='GOOGLE'){
                    this.isUserExists = true;
                }
                this.changeSignUpPage(3);
                if(this.userSnap?.additionalUserInfo?.isNewUser && this.clientDetails.email)
                    this.sendOnboardingEmail(this.clientDetails.email);
                console.log('this.$route.query first->',this.$route.query)
                // if(this.$route.query && this.$route.query.clioFetch == 'true'){
                //     localStorage.setItem('redirectRouteParams',JSON.stringify(this.$route.query))
                //     clioLogin();
                // } else {

                
                // }
            }
            }).catch((err)=>{
                console.log(err)
                this.signupError = this.googleErrorMessage(err);
            }).finally(() => {
                this.providerBusy = false;
            })
        },
        googleErrorMessage(error) {
            const closed = 'Google sign-in was closed before it finished. Try again, or use email.';
            const unsupported = 'Google sign-in doesn\'t work in this browser. Open this page in Chrome or Safari, or use email.';
            const messages = {
                'auth/popup-closed-by-user': closed,
                'auth/cancelled-popup-request': closed,
                'auth/popup-blocked': 'Your browser blocked the Google window. Allow pop-ups for this site, or use email.',
                'auth/network-request-failed': 'We couldn\'t reach Google. Check your connection and try again.',
                'auth/web-storage-unsupported': unsupported,
                'auth/operation-not-supported-in-this-environment': unsupported,
            };
            return messages[error && error.code] || 'Google sign-in didn\'t work. Try again, or use email.';
        },
        async setValuesAfterGoogleSignUp(loggedInEmail){
            this.isUserExists = false;
            let userAlreadySignedUp = await this.getCustomerUsingEmail(loggedInEmail)
            console.log('userAlreadySignedUp-->',userAlreadySignedUp)

            if(Object.keys(userAlreadySignedUp).length){
                this.isUserExists = true;
                // this.infoMessage('User Exists','The user exists already. Please update the details here / proceed to login TAB for user login');
                if(userAlreadySignedUp.displayName)
                    this.clientDetails.firstName = userAlreadySignedUp.displayName
                if(userAlreadySignedUp.lastName)
                    this.clientDetails.lastName = userAlreadySignedUp.lastName;
                if(userAlreadySignedUp.email)
                    this.clientDetails.email = userAlreadySignedUp.email;
                if(userAlreadySignedUp.organizationName)
                    this.clientDetails.organizationName = userAlreadySignedUp.organizationName;
                // if(userAlreadySignedUp.phoneNumber)
                //     this.clientDetails.phoneNumber = userAlreadySignedUp.phoneNumber;
                if(userAlreadySignedUp.locationOfPractice)
                    this.clientDetails.locationOfPractice = userAlreadySignedUp.locationOfPractice;
            }
            this.emailDisabled = true;
        },
        async signUpWithEmail() {
            await this.setAuthProvider('EMAIL');
            this.resetSignUpForm();
            this.changeSignUpPage(3)
        },
        setAuthProvider(provider){
            this.emailDisabled = false;
            this.loginError = null;
            this.signupError = null;
            return new Promise(resolve => {
                this.authProvider = provider;
                this.$store.commit('setLoginProvider',provider);
                if(this.$route.query.authProvider !== provider){
                    resolve(this.$router.push({
                        query: { ...this.$route.query, authProvider: provider },
                    }).catch(()=>{}))
                } else {
                    resolve(true)
                }
            });
        },
        // Written on the Google paths before the customer record exists;
        // users/{uid} needs an authed request.
        async writePartyTrialAndHold(userId, requiresPayment){
            if(!userId){
                console.error('[party-hold] no userId, skipping');
                return;
            }
            try {
                const trialEnd = addDays(new Date(), 36500).toISOString(); // 100 years
                await usersCollection.doc(userId).set({
                    trialEnd: trialEnd,
                    requiresPayment: requiresPayment
                }, { merge: true });
            } catch (error) {
                console.error('[party-hold] failed writing trialEnd/requiresPayment:', error);
            }
        },
        async saveUserDataToCollection(userAlreadySignedUp){
            return new Promise(async(resolve, reject) => {
            let roleLevel = null 
            if(this.currentRole === 'party'){
                roleLevel = 'client-level-1'
            }
            else if(this.currentRole === 'assistant'){
                roleLevel = 'assistant-level-1'
            } else {
                this.currentRole = 'lawyer';
                roleLevel = 'lawyer-level-1';
            }
            let isSharedUser = false
            console.log('saveUserDataToCollection role->',roleLevel)
            if((!userAlreadySignedUp || !userAlreadySignedUp.roleLevel) && this.agreementId){
              let rolelevelPerAgreement = await this.getRoleLevelPerAgreementOfCustomer().catch((err)=>{console.log('er-->',err)});
              if(rolelevelPerAgreement){
                // For lawyers: Keep default roleLevel (lawyer-level-1) in customers collection
                // The agreement-specific role is already stored in agreements/{id}/users/permissions
                // and will be used when viewing that specific agreement
                // For party/assistant: Keep current behavior (overwrite with agreement-specific role)
                if(this.currentRole !== 'lawyer'){
                  roleLevel = rolelevelPerAgreement
                }
                isSharedUser = true
              }
            }   
            
            // console.log('this.userSnap.user.uid',this.userSnap.user.uid);
            let userId = (this.userSnap && this.userSnap.user && this.userSnap.user.uid) ? this.userSnap.user.uid : this.signupUserId;
            const dataToSet = {
                displayName:  this.clientDetails.firstName,
                lastName: this.clientDetails.lastName,
                email: this.clientDetails.email,
                organizationName: this.clientDetails.organizationName,
                // phoneNumber: this.clientDetails.phoneNumber,
                locationOfPractice: this.clientDetails.locationOfPractice,
                roleLevel: roleLevel,
                roleAssociated:this.currentRole,
                isSharedUser: isSharedUser,
                marketingConsent: this.clientDetails.marketingConsent
            };
            console.log('dataToSet-->',dataToSet)
            let customerAddUpdate = await this.updateCustomersCollectionWithRetry(dataToSet,userId)
                                    .catch((err)=>{
                                        console.error('err-=-=->>>',err);
                                        reject(err)
                                    });
            // BACKUP CODE of v1.9
            // let customerAddUpdate = await customersCollection.doc(userId).set(dataToSet, { merge: true })
            // .catch((err)=>{
            //     console.error('err-=-=->>>',err);
            //     reject(err)
            // });

            if(this.agreementId){
                console.log('----',this.agreementId)
                await this.setAgreementDetailsToUserCollection(userId,this.clientDetails.email);
            }

            const currentAuthUser = auth.currentUser;
            if(this.currentRole === 'party' && currentAuthUser && currentAuthUser.uid === userId) {
                await this.writePartyTrialAndHold(userId, false);
            }
            const setTrialEnd = firebaseApp.functions('northamerica-northeast1').httpsCallable('publicApi-setTrialEnd');

            const userData = await setTrialEnd({
                id: userId,
                role: this.currentRole
            });

            console.log('customerAddUpdate',customerAddUpdate);
             resolve(customerAddUpdate)
            });
        },
        async updateCustomersCollectionWithRetry(dataToSet,userId) {
            return new Promise(async (resolve) => {
                let attempts = 0;
                let success = false;
                const maxAttempts = 3;
                const delayMs = 1000;
                const updateCustomer = firebaseApp
                    .functions('northamerica-northeast1')
                    .httpsCallable('publicApi-updateCustomer');

                while (attempts < maxAttempts && !success) {
                    try {
                        const response = await updateCustomer({ id: userId, data: dataToSet });
                        if (response && response.data && response.data.success) {
                            success = true;
                            console.log("Customer updated successfully.");
                        } else {
                            throw new Error('Customer update returned unsuccessful response');
                        }
                    } catch (error) {
                    console.error("Err Customer updation fail:", attempts + 1," attempt->", error);
                    attempts++;
                    if (attempts < maxAttempts) {
                        await new Promise(r => setTimeout(r, delayMs)); // Delay before retry
                    }
                    }
                }

                if (!success) {
                    console.error(`Failed to update Customer after ${maxAttempts} attempts.`);
                 }
                 resolve(success);
            })
        },
        async setAgreementDetailsToUserCollection(userId,emailId){
            return new Promise(async(resolve, reject) => {

                const setAgreementDetailsToUser = firebaseApp.functions('northamerica-northeast1').httpsCallable('publicApi-setAgreementDetailsToUser');
				let body={
					agreementId: this.agreementId,
					userId: userId,
                    emailId:emailId,
                    checkPendingInvites:true
				}
                console.log('body',body)
				const agrDetailsSetting = await setAgreementDetailsToUser(body).catch((error) => {
                        console.error('Error getting documents: ', error);
                        return resolve()
                      });
                resolve(agrDetailsSetting)
                // await usersCollection.doc(userId).get().then(async (doc) => {
                // console.log('doc.exists',doc.exists)
                // if (doc.exists) {
                //     console.log('doc.data()',doc.data())
                //     const agreements = doc.data().agreements || [];
                //     const hasMatchingId = agreements.some(agreement => agreement.id === this.agreementId);
                //     console.log('hasMatchingId',hasMatchingId)
                //         if (hasMatchingId) {
                //             console.log('Document found:', {
                //             id: doc.id,
                //             data: doc.data(),
                //             });
                //             resolve();
                //         } else {
                //             console.log('this.agreementId',this.agreementId)
                //             let singleAgreementDetails = await agreementsCollection.doc(this.agreementId).get().catch((error) => {
                //                                                     console.error('Error getting agreements: ', error);
                //                                                     reject(error)
                //                                                 })
                //             if(singleAgreementDetails?.data()){
                //                 const agreementData = singleAgreementDetails?.data();
                //                 console.log('agreementData',agreementData)
                //                 const newDataToAdd = {
                //                     id: this.agreementId,
                //                     title: agreementData.title,
                //                     createdOn: agreementData.createdOn,
                //                     updatedAt: agreementData.updatedAt,
                //                 };
                //                 let userCollectionUpdate = await usersCollection.doc(userId).update({
                //                     agreements: [...agreements, newDataToAdd],
                //                 }).catch((error) => {
                //                     console.error('Error updating usersCollection: ', error);
                //                     reject(error)
                //                 })
                //                 console.log('agreementData ---')
                //                 resolve();
                //             }
                //         }
                //     } else {
                //     console.log('Document does not exist.');
                //     resolve();
                //     }
                // })
                // .catch((error) => {
                //     console.error('Error getting documents: ', error);
                //     reject(error)
                // });
            })
        },
        async getRoleLevelPerAgreementOfCustomer(){
            return new Promise(async(resolve, reject) => {
                let rolePerAgreement = '';
                if(this.agreementId){
                    let perm = await agreementsCollection
                                        .doc(this.agreementId)
                                        .collection("users")
                                        .doc("permissions")
                                        .get()
                                        .catch((err)=>{
                                            console.error(err);
                                            reject()
                                        });
                    console.log('perm->',perm.data());
                    const permissionData = perm.data();
                    let permissionObjKeys = Object.keys(permissionData);
                    if(permissionData && permissionObjKeys?.length){
                        console.log('1');
                        for(let i=0; i<permissionObjKeys.length ; i++){
                            console.log('2',this.clientDetails?.email,permissionData[permissionObjKeys[i]].email);
                            if(this.clientDetails?.email && permissionData[permissionObjKeys[i]].email && this.clientDetails.email == permissionData[permissionObjKeys[i]].email){
                                rolePerAgreement = permissionData[permissionObjKeys[i]].role;
                            }
                        }
                    }
                }
                resolve(rolePerAgreement);
            })
        },
        async createAccount() {
            if (this.signUpLoading) return;
            this.$v.clientDetails.$touch();
            if (this.$v.clientDetails.$anyError) {
                this.focusFirstError();
                return;
            }
            this.emailInUse = false;
            try {
				this.signUpLoading = true;
				this.$store.commit('setSigningUp', true);
                const userAlreadySignedUp = await this.getCustomerUsingEmail(this.clientDetails.email)
                let alreadyHadAccount = false;
                if((this.authProvider == 'EMAIL' || this.authProvider == 'CLIO') && !this.emailDisabled){
                    try {
                        this.userSnap = await this.createUserWithEmailAndPasswordQuery(
                            this.clientDetails.email,
                            this.clientDetails.password
                        );
                    } catch (error) {
                        if (error.code !== 'auth/email-already-in-use') throw error;
                        this.userSnap = await this.signInWithEmailAndPasswordQuery(
                            this.clientDetails.email,
                            this.clientDetails.password
                        ).catch(() => { throw error; });
                        const savedProfile = await this.getCustomerUsingID(this.userSnap.user.uid);
                        alreadyHadAccount = Boolean(savedProfile.roleLevel || savedProfile.roleAssociated || savedProfile.displayName);
                    }
                    // this.userSnap = await auth.signInWithEmailAndPassword(
                    //     this.clientDetails.email,
                    //     this.clientDetails.password
                    // );
                    console.log('1')
                } else if(this.emailDisabled && this.clientDetails.email){
                    if(!this.isUserExists){
                        if(Object.keys(userAlreadySignedUp).length && userAlreadySignedUp.roleLevel){
                            this.userSnap = await this.signInWithEmailAndPasswordQuery(
                                this.clientDetails.email,
                                this.clientDetails.password
                            );
                        } else {
                            this.userSnap = await this.createUserWithEmailAndPasswordQuery(
                                this.clientDetails.email,
                                this.clientDetails.password
                            );
                        }
                    }
                    console.log('2')
                }
///////////////////////////////////////
                if (alreadyHadAccount) {
                    if (this.agreementId) {
                        await this.setAgreementDetailsToUserCollection(this.userSnap.user.uid, this.userSnap.user.email);
                    }
                } else {
                    await this.saveUserDataToCollection(userAlreadySignedUp);
                    console.log('3')
                    // Track signup event
                    this.$posthog.capture('user_signup', {
                        user_id: this.userSnap?.user?.uid || this.signupUserId,
                        role: this.currentRole || '',
                        email: this.clientDetails.email,
                        auth_provider: this.authProvider || 'unknown',
                        agreement_id: this.agreementId || null,
                    });
                }

                if(this.authProvider !== 'CLIO' && this.userSnap?.user && auth.currentUser){
                    clearSignupInProgress();
                    const provider = this.authProvider ? this.authProvider.toUpperCase() : 'EMAIL';
                    this.$store.commit('setLoginProvider', provider);
                    await this.$store.dispatch('login', this.userSnap.user);
                    localStorage.removeItem('redirectRouteParams');
                    await this.$router.push({ name: 'home' }).catch(() => {});
                    this.signUpLoading = false;
                    this.$store.commit('setSigningUp', false);
                    return;
                }

                let routeParamsObj;
                if(localStorage.getItem('redirectRouteParams')){
					routeParamsObj = JSON.parse(localStorage.getItem('redirectRouteParams'));
                    routeParamsObj.page = 1;
                    routeParamsObj.auth = 0;
                    // this.$router.push({ name: 'auth' ,query :routeParamsObj});
                    this.$router.replace({query: routeParamsObj}).catch(() => {});
                    localStorage.removeItem('redirectRouteParams');
                } else {
                    this.$router.replace({query: {page:1,auth:0}}).catch(() => {});
                }
                this.$store.dispatch('logout');
                this.$store.commit('setLoggingOut', false);
                this.accountCreated = true;
                this.successMessage('Account Created','Please login using the credentials to access DIVII');
                this.signUpLoading = false;
                this.$store.commit('setSigningUp', false);
                // let authProvider = this.authProvider ? this.authProvider.toUpperCase() : 'EMAIL';
				// this.$store.commit('setLoginProvider',authProvider);
				// this.$store.dispatch('login', this.userSnap.user).then(async () => {				
				// console.log(`User ${this.userSnap.user.email} logged in`);
				// 	if(this.getClientOrPreviouslyLoggedId){
				// 			console.log('==>>>')
				// 			await fb.customersCollection.doc(this.userSnap.user.uid).set({
				// 				isClientUser : true,
				// 			}, { merge: true }).catch((err)=>{
				// 				console.error('err***',err);
				// 				return ;//reject(err)
				// 			});
				// 			this.signUpLoading = false;
				// 			if(this.getPreviouslyLoggedClientUserAgreement)
				// 				localStorage.setItem('clientUserAgreement', this.getPreviouslyLoggedClientUserAgreement);
				// 			this.$router.push({
				// 				name: 'clientUserAgreement',
				// 				params: { id: this.getClientOrPreviouslyLoggedId },
				// 			});
				// 	} else {
				// 			this.signUpLoading = false;
				// 			this.$router.push({ name: 'home' });
				// 	}
                //     localStorage.removeItem('redirectRouteParams');
				// });

			}
             catch (error) {
				var errorCode = error.code;
				var errorMessage = error.message;
				console.error(errorCode, errorMessage);
                if (errorCode == 'auth/email-already-in-use') {
					this.emailInUse = true;
				}
                else{
                    this.signupError = 'There was a problem setting up your account please try again.';
                    this.errorMessage('',this.signupError)

                }	
                this.signUpLoading = false;
                this.$store.commit('setSigningUp', false);
                
			}
        },
        async signInWithClio() {
            this.providerBusy = true;
            await this.setAuthProvider('CLIO');
            if(this.$route.query)
                localStorage.setItem('redirectRouteParams',JSON.stringify(this.$route.query))
                clioLogin();
        },
        signInWithGoogle() {
            this.providerBusy = true;
            this.setAuthProvider('GOOGLE');
            const provider = new firebase.auth.GoogleAuthProvider();
            provider.setCustomParameters({
                prompt: 'select_account'
            });
            this.isUserExists = false;
            auth.signInWithPopup(provider).then(async (googleResponse)=>{
                markSignupInProgress(googleResponse.user.uid, this.$route.name);
                console.log('google resp-->',googleResponse)
                this.userSnap = googleResponse;
                let userAlreadySignedUp = await this.getCustomerUsingEmail(this.userSnap.additionalUserInfo.profile.email)
                console.log('googleResponse-->',googleResponse) 
                console.log('userAlreadySignedUp-->',userAlreadySignedUp);
                if(this.userSnap.additionalUserInfo &&  this.userSnap.additionalUserInfo.profile)
                    localStorage.setItem('loggedInEmailID',this.userSnap.additionalUserInfo.profile.email);
                if(Object.keys(userAlreadySignedUp).length && userAlreadySignedUp.roleLevel){
                    clearSignupInProgress();
                    await this.loginExistingGoogleUser();
                } else
                if(this.userSnap) {
                    this.isUserExists = true;
                    if(this.userSnap.additionalUserInfo &&  this.userSnap.additionalUserInfo.profile){
                        this.clientDetails.firstName =  this.userSnap.additionalUserInfo.profile.given_name;
                        this.clientDetails.lastName =  this.userSnap.additionalUserInfo.profile.family_name;
                    }
                    this.clientDetails.email =  this.userSnap.additionalUserInfo.profile.email;
                    this.emailDisabled = true;
                    this.activeTab = 1;
                    // await this.changeTab(1,1);
                    // this.changeSignUpPage(3);
                    
                    if(this.currentRole === 'party') {
                        await this.writePartyTrialAndHold(this.userSnap.user?.uid, false);
                    }

                    this.$router.replace({
                        query: { ...this.$route.query, auth: 1, page:3 },
                    }).catch(() => {});

                    if(this.agreementId){
                        console.log('----')
                        await this.setAgreementDetailsToUserCollection(this.userSnap.user.uid,this.userSnap.user.email);
                    }
                }

            }).catch((err)=>{
                console.log(err)
                this.loginError = this.googleErrorMessage(err);
            }).finally(() => {
                this.providerBusy = false;
            })
        },
        async loginExistingGoogleUser() {
            this.isUserExists = true;
            await this.fetchRoleLevel(this.userSnap.additionalUserInfo.profile.email);
            if(this.agreementId){
                await this.setAgreementDetailsToUserCollection(this.userSnap.user.uid,this.userSnap.user.email);
            }

            if(this.$route.query && this.$route.query.clioFetch == 'true'){
                localStorage.setItem('redirectRouteParams',JSON.stringify(this.$route.query))
                clioLogin();
            } else {
                await this.$router.push({ name: 'home' }).catch(() => {});
            }
        },
        async signInWithEmail() {
            await this.setAuthProvider('EMAIL');
            this.changeloginPage(3)
        },
        async getCustomerUsingID(uid){
            try {
                const cust  = await customersCollection.doc(uid).get();
                console.log('cust-->',cust.data())
                return cust && cust.data() ? cust.data() : {};
            } catch (error) {
                console.log("the error is happening in getCustomerUsingID", error);
            }
			
		},
        // Incoming changes from feature/updated-signup branch, if the existing function doesn't work, we can check with this one instead.
        // async getCustomerUsingEmail(email){
		// 	const customers  = await customersCollection.where("email", "==", email).get();
        //     const data = customers.docs.map((doc) => doc.data());
        //     return data[0] || {};
        // },
        async getCustomerUsingEmail(email) {
            try {
                const fetchCustomerUsingEmail = firebaseApp.functions('northamerica-northeast1').httpsCallable('publicApi-fetchCustomerUsingEmail');
                const response = await fetchCustomerUsingEmail({ email });
                console.log("this is the response data==>",response.data);
                return response.data.customer || {};
            } catch (error) {
                console.error("Error checking customer existence:", error);
                return false; // Assume customer doesn't exist in case of an error
            }
        },
        async fetchRoleLevel(email) {
            try {
                const fetchCustomerUsingEmail = firebaseApp.functions('northamerica-northeast1').httpsCallable('publicApi-fetchCustomerUsingEmail');
                const response = await fetchCustomerUsingEmail({ email });
                const data = response.data.customer
                if (data) {
                    const fetchedRoleLevel = data.roleLevel || 'lawyer-level-1';
                    const foundRoleLevel = this.roleLevels.find(role => role.roleName === fetchedRoleLevel);
                    console.log("this is the fetrched role level==", fetchedRoleLevel);
                    if (foundRoleLevel) {
                        this.$store.dispatch('setCurrentRole', foundRoleLevel.roleAssociated);
                    }
                    return fetchedRoleLevel;
                }
                return undefined;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
        async login() {
            if (this.loginLoading) return;
            this.$v.loginDetails.$touch();
            if(this.$v.loginDetails.$anyError){
                this.focusFirstError();
                return
            }
            this.loginLoading = true;
            this.loginError = null;
            try {

                await this.fetchRoleLevel(this.loginDetails.email);

                const userSnap = await this.signInWithEmailAndPasswordQuery(
					this.loginDetails.email,
					this.loginDetails.password
				);
				// this.$store.commit('setLoginProvider', 'EMAIL')
				await this.$store.dispatch('login', userSnap.user).then(async() => {
					
					console.log(`User ${userSnap.user.email} logged in`);
						let loggedInCustomer = await this.getCustomerUsingID(userSnap.user.uid);
						console.log(`User abc--> ${JSON.stringify(loggedInCustomer)}`);
                        localStorage.removeItem('redirectRouteParams');

                        
                        if(this.agreementId){
                            console.log('----')
                            await this.setAgreementDetailsToUserCollection(userSnap.user.uid,userSnap.user.email);
                        }
						// if(this.getClientOrPreviouslyLoggedId && loggedInCustomer && loggedInCustomer.isClientUser){
						// 	if(this.getPreviouslyLoggedClientUserAgreement)
						// 		localStorage.setItem('clientUserAgreement', this.getPreviouslyLoggedClientUserAgreement);
						// 	this.$router.push({
						// 		name: 'clientUserAgreement',
						// 		params: { id: this.getClientOrPreviouslyLoggedId },
						// 	});
						// } else {
                            let loginProvider = localStorage.getItem('loginProvider');
                            if(this.$route.query && this.$route.query.clioFetch == 'true' && loginProvider != 'CLIO'){
                                    localStorage.setItem('redirectRouteParams',JSON.stringify(this.$route.query))
                                    clioLogin();
                            } else {
						        await this.$router.push({ name: 'home' }).catch(() => {});
                            }
                            this.loginLoading = false;
                        // }
					
				});
                
			}  catch (error) {
				// Handle Errors here.
				var errorCode = error.code;
				var errorMessage = error.message;
				console.error(errorCode, errorMessage);
                this.loginLoading = false;
				if (errorCode == 'auth/user-not-found') {
					this.loginError = 'We couldn\'t find an account with that email.';
				} else if (
					errorCode == 'auth/wrong-password' ||
					errorCode == 'auth/invalid-email' ||
					errorCode == 'auth/invalid-credential' ||
					errorCode == 'auth/invalid-login-credentials'
				) {
					this.loginError = 'That email and password don\'t match. If you signed up with Google, use Log in with Google instead.';
				} else if (errorCode == 'auth/too-many-requests') {
					this.loginError = 'Too many attempts. Wait a few minutes or reset your password.';
				} else if (errorCode == 'auth/user-disabled') {
					this.loginError = 'This account has been disabled. Please contact Divii support.';
				} else {
                    this.loginError = 'Something went wrong. Check your connection and try again.';
                }
			}
        },
        onPageShow(event) {
            if (event.persisted) this.providerBusy = false;
        },
        errorIdIf(fieldId, hasError) {
            return hasError ? `${fieldId}-error` : null;
        },
        focusFirstError() {
            this.$nextTick(() => {
                const firstInvalid = this.$el.querySelector('.is-invalid');
                if (firstInvalid) firstInvalid.focus();
            });
        },
        openForgotPassword() {
            this.resetEmail = this.loginDetails.email;
            this.$router.push({ query: { ...this.$route.query, forgot: '1' } }).catch(() => {});
        },
        forceLogout(){
            this.$store.dispatch('logout');
            this.$store.commit('setLoggingOut', false);
        },
        sendInstructions(){
            if (this.resetPasswordLoading) return;
            this.$v.resetEmail.$touch();
            if(this.$v.resetEmail.$anyError){
                this.focusFirstError();
                return
            }
            this.resetPasswordError = null;
            this.resetPasswordLoading = true
            auth.sendPasswordResetEmail(this.resetEmail).then(() => {
                this.resetPasswordLoading = false;
                this.resetEmailSent = true;
                console.log("Reset password link sent successfully")
            })
            .catch(error => {
                this.resetPasswordLoading = false;
                this.resetEmailSent = false;
                this.resetPasswordError = error.message;
                console.error("ERROR:", error.message)
            });
        },
        resetSignUpForm(){
            this.clientDetails = {
                firstName: '',
                lastName: '',
                organizationName: '',
                locationOfPractice: '',
                // locationOfPractice: 'British Columbia', /* Release 2.2 */
                email: '',
                // phoneNumber: '',
                password: '',
                termsOfService: false,
                marketingConsent: false,
            }
            this.$v.clientDetails.$reset()
            this.signupError = null
            this.emailInUse = false
        },
        async goToLogin(resetPassword) {
            const email = this.clientDetails.email;
            await this.changeTab(null, 0);
            this.loginDetails.email = email;
            if (resetPassword) {
                this.openForgotPassword();
            } else {
                this.signInWithEmail();
            }
        },
        resetLoginForm(){
            this.$v.loginDetails.$reset()
            this.loginError = null
        },
        setQueryValuesToPage(query){
            // if role param exists in the given roles set param value, otherwise set 'lawyer' by default.
            this.currentRole = Object.keys(this.roles).includes(query.role) ? query.role : this.userType === 'lawyer'? 'lawyer': 'party';
            this.$store.dispatch('setCurrentRole', this.currentRole);
            this.activeTab = query.auth ? Number(query.auth) : 0
            this.connectClio = query.clioFetch || false;
            this.authProvider =  query.authProvider || '';
            this.agreementId = query.id || '';
            this.invitedRoleLevel = query.roleLevel || '';
            const page = query.page ? Number(query.page) : 1;
            this.isGoBackVisible = query.isGoBackVisible !== 'false';
            if(this.activeTab == 0){            
                this.$store.dispatch('setCurrentLoginPageAction',page); 
            } else {
                this.$store.dispatch('setCurrentSignUpPageAction',page); 
            }
        },
        signInWithEmailAndPasswordQuery(email,password){
            return new Promise(async (resolve,reject)=>{
                const userSnap = await auth.signInWithEmailAndPassword(email,password)
                                            .catch((err)=>{
                                                console.error(err);
                                                return reject(err)
                                            });
                resolve(userSnap);
            })
        },
        createUserWithEmailAndPasswordQuery(email,password){
            return new Promise(async (resolve,reject)=>{
                await auth.createUserWithEmailAndPassword(email,password)
                                            .then(async (userSnap) => {
                                                this.sendOnboardingEmail(email);
                                                resolve(userSnap);
                                            })
                                           .catch((err)=>{
                                                console.error(err);
                                                return reject(err)
                                           });
                
                // this.sendOnboardingEmail(email);    
				// await onboardingEmailRequest(body)

                // resolve(userSnap);
            })
        },
        async sendOnboardingEmail(email){

                //const onboardingEmailRequest = firebaseApp.functions('northamerica-northeast1').httpsCallable('emailApi-sendOnboardingEmail');
				let body={
					toEmail: email,
                    host: window.location.host,
                    role: this.userType,
                    firstName: this.clientDetails.firstName,
                    logo: "http://cdn.mcauto-images-production.sendgrid.net/48d4432ce91ad829/87cc08af-2b73-4b9a-b621-d10bdfdae2b1/1494x501.png",
				}
                console.log('body',body)
                const emailReq =  await emailApiRequest('POST','/onboardingEmail',body).catch((err)=> console.log('onboardingEmail err->',err));
                console.log('emailReq',emailReq)
        }
    },
    beforeDestroy() {
        document.title = 'Divii';
        window.removeEventListener('pageshow', this.onPageShow);
    },
    watch: {
        pageTitle: {
            immediate: true,
            handler(title) {
                document.title = title;
            }
        },
        '$route.query': {
            immediate: true,
            handler(newQuery, oldQuery) {
                console.log('newQuery',newQuery)
                if (newQuery)
                    this.setQueryValuesToPage(newQuery);
                this.forgotPassword = newQuery.forgot === '1';
                const leftSignupForm = oldQuery && Number(oldQuery.auth) === 1 && Number(oldQuery.page) === 3
                    && Number(newQuery.auth) === 1 && Number(newQuery.page) < 3;
                if (leftSignupForm) {
                    this.forceLogout();
                    this.resetSignUpForm();
                }
            }
        },
        '$v.loginDetails.email.$model': {
            handler: function (value) {
                this.loginError = '';
            },
            deep: true,
    },
    },
    beforeRouteLeave(to, from, next) {
    const currentStep = this.activeTab === 0 ? this.currentLoginPage : this.currentSignUpPage;
    const eventName = this.activeTab === 0 ? 'login_page_dropoff' : 'signup_page_dropoff';

    this.$posthog.capture(eventName, {
      step: currentStep,
      to_page: to.name || 'unknown',
      to_url: to.fullPath,
      user_id: this.userSnap?.user?.uid || this.signupUserId || null,
      role: this.$store.state.posthogRole || '',
      auth_provider: this.authProvider || 'unknown',
      timestamp: new Date().toISOString(),
    });

    next();
  },
};
</script>

<template>
    <div class="auth-page" :class="{
        'auth-page-split': showSignupIntro || showLoginIntro,
        'auth-page-form': activeTab === 1 && currentSignUpPage === 3,
        'auth-page-lawyer': userType === 'lawyer',
        'auth-page-login-intro': showLoginIntro,
    }">
        <section class="auth-card">
            <fieldset class="auth-fieldset" :disabled="formBusy" :aria-busy="formBusy">
            <template v-if="activeTab === 0">
                <div v-if="forgotPassword" key="forgot" data-testid="forgot-password-page">
                    <button type="button" class="auth-back" @click="$router.back()" data-testid="forgot-password-go-back">
                        <b-icon-arrow-left /> Back
                    </button>
                    <h1 class="auth-title">Reset your password</h1>
                    <p class="auth-subtitle">Enter the email you signed up with. If we find it, we'll send you a reset link.</p>
                    <b-form-group label="Email" label-for="reset-email" class="auth-field">
                        <b-form-input id="reset-email" type="email" autocomplete="username" class="auth-input"
                            v-model="resetEmail" @blur="$v.resetEmail.$touch()" :state="validateState('', 'forgotPassword')"
                            :aria-describedby="errorIdIf('reset-email', $v.resetEmail.$error)"
                            data-testid="forgot-password-email" @keydown.enter="sendInstructions" />
                        <b-form-invalid-feedback id="reset-email-error" v-if="!$v.resetEmail.required">Email is required</b-form-invalid-feedback>
                        <b-form-invalid-feedback id="reset-email-error" v-if="!$v.resetEmail.email">This must be a valid email address.</b-form-invalid-feedback>
                    </b-form-group>
                    <b-button block class="auth-primary-btn" :disabled="resetPasswordLoading"
                        @click="sendInstructions" data-testid="send-instructions">
                        <b-spinner v-if="resetPasswordLoading" small />
                        <span v-else-if="resetEmailSent">Send again</span>
                        <span v-else>Send reset link</span>
                    </b-button>
                    <div v-if="resetEmailSent" class="auth-alert auth-alert-success">
                        Sent to <b>{{ resetEmail }}</b>. Not there in a few minutes? Check your junk or spam folder.
                    </div>
                    <div v-else-if="resetPasswordError" class="auth-alert auth-alert-error">{{ resetPasswordError }}</div>
                    <p class="auth-footnote">
                        Signed up with Google? You don't need a password.
                        <a href="#" @click.prevent="changeloginPage(1)">Log in with Google</a>
                    </p>
                </div>

                <div v-else-if="currentLoginPage === 3" key="login-email" data-testid="login-page">
                    <button type="button" class="auth-back" @click="changeloginPage(1);resetLoginForm()" data-testid="login-go-back-2">
                        <b-icon-arrow-left /> Back
                    </button>
                    <h1 class="auth-title">Log in with email</h1>
                    <b-form-group label="Email" label-for="login-email" class="auth-field">
                        <b-form-input id="login-email" type="email" autocomplete="username" class="auth-input"
                            v-model="loginDetails.email" @blur="$v.loginDetails.email.$touch()" :state="validateState('email', 'login')"
                            :disabled="emailDisabled" :aria-describedby="errorIdIf('login-email', $v.loginDetails.email.$error)"
                            data-testid="login-email-input" />
                        <b-form-invalid-feedback id="login-email-error" v-if="!$v.loginDetails.email.required">Email is required</b-form-invalid-feedback>
                        <b-form-invalid-feedback id="login-email-error" v-if="!$v.loginDetails.email.email">This must be a valid email address.</b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group label="Password" label-for="login-password" class="auth-field">
                        <div class="auth-password">
                            <b-form-input id="login-password" :type="showPassword ? 'text' : 'password'" autocomplete="current-password"
                                class="auth-input" v-model="loginDetails.password" @blur="$v.loginDetails.password.$touch()" :state="validateState('password', 'login')"
                                :aria-describedby="errorIdIf('login-password', $v.loginDetails.password.$error)"
                                data-testid="login-password-input" @keydown.enter="login" />
                            <button type="button" class="auth-show-btn" @click="showPassword = !showPassword">{{ showPassword ? 'Hide' : 'Show' }}</button>
                        </div>
                        <div id="login-password-error" v-if="$v.loginDetails.password.$error" class="invalid-feedback d-block">Password is required</div>
                    </b-form-group>
                    <div class="auth-forgot">
                        <a href="#" @click.prevent="openForgotPassword" data-testid="forgot-password-btn">Forgot password?</a>
                    </div>
                    <b-button block class="auth-primary-btn" :disabled="loginLoading"
                        @click="login" data-testid="login-btn">
                        <template v-if="loginLoading"><b-spinner small /> Logging in…</template>
                        <span v-else>Log in</span>
                    </b-button>
                    <div v-if="loginError" class="auth-alert auth-alert-error">{{ loginError }}</div>
                    <p class="auth-footnote">New to Divii? <a href="#" @click.prevent="changeTab($event, 1)">Create an account</a></p>
                </div>

                <div v-else key="login-choose" data-testid="login-page">
                    <div v-if="accountCreated" class="auth-alert auth-alert-success">Your account is ready. Log in to continue.</div>
                    <h1 class="auth-title">Log in</h1>
                    <p class="auth-subtitle">Use the same option you signed up with.</p>
                    <div v-if="currentRole === 'lawyer' || currentRole === 'assistant'" class="auth-note">
                        <b-form-checkbox switch v-model="connectClio" @change="handleClioCheckbox" data-testid="clio-import-checkbox">
                            Also bring in my Clio matters
                        </b-form-checkbox>
                        <span>Turn this on before you choose how to log in. You'll sign in to Clio after this.</span>
                    </div>
                    <div class="auth-providers">
                        <button v-if="currentRole !== 'party'" type="button" class="auth-provider-btn"
                            @click="signInWithClio" data-testid="clio-sign-in">
                            <img src="@/assets/clioLogo.svg" alt="" /> Log in with Clio
                        </button>
                        <button type="button" class="auth-provider-btn" @click="signInWithGoogle" data-testid="google-sign-in">
                            <img src="@/assets/googleLogo.svg" alt="" /> Log in with Google
                        </button>
                        <button type="button" class="auth-provider-btn" @click="signInWithEmail" data-testid="email-sign-in">
                            <b-icon-envelope /> Log in with email
                        </button>
                    </div>
                    <div v-if="loginError" class="auth-alert auth-alert-error">{{ loginError }}</div>
                    <div v-if="currentRole !== 'lawyer' && currentRole !== 'assistant'" class="auth-note">
                        New and got an invite? Open the link in your invite email so you're taken straight to the shared agreement.
                    </div>
                    <p class="auth-footnote">New to Divii? <a href="#" @click.prevent="changeTab($event, 1)">Create an account</a></p>
                </div>
            </template>

            <template v-else>
                <ol class="auth-steps" :style="{ gridTemplateColumns: `repeat(${signupSteps.length}, minmax(0, 1fr))` }">
                    <li v-for="(step, index) in signupSteps" :key="step"
                        :class="{ 'auth-step-done': index <= signupStepIndex, 'auth-step-current': index === signupStepIndex }">
                        {{ index + 1 }} · {{ step }}
                    </li>
                </ol>

                <div v-if="currentSignUpPage === 3" key="signup-form" data-testid="signup-3">
                    <button type="button" class="auth-back" @click="changeSignUpPage(2)" data-testid="signup-go-back-2">
                        <b-icon-arrow-left /> Back
                    </button>
                    <template v-if="authProvider === 'GOOGLE'">
                        <h1 class="auth-title">Almost done</h1>
                        <p class="auth-subtitle">Your Google account is connected. Check your name and agree to the terms.</p>
                        <div class="auth-google-account">
                            <span class="auth-avatar" aria-hidden="true">{{ googleInitial }}</span>
                            <span class="auth-google-name">
                                <b>{{ clientDetails.firstName }} {{ clientDetails.lastName }}</b>
                                <span>{{ clientDetails.email }}</span>
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <h1 class="auth-title">{{ signupFormTitle }}</h1>
                        <p class="auth-subtitle">All fields are required unless marked optional.</p>
                    </template>

                    <form class="auth-form" @submit.prevent="createAccount">
                        <div class="auth-row">
                            <b-form-group label="First name" label-for="signup-first-name" class="auth-field">
                                <b-form-input id="signup-first-name" autocomplete="given-name" class="auth-input"
                                    v-model="clientDetails.firstName" @blur="$v.clientDetails.firstName.$touch()" :state="validateState('firstName')"
                                    :aria-describedby="errorIdIf('signup-first-name', $v.clientDetails.firstName.$error)"
                                    data-testid="signup-first-name-input" />
                                <b-form-invalid-feedback id="signup-first-name-error">First name is required</b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group label="Last name" label-for="signup-last-name" class="auth-field">
                                <b-form-input id="signup-last-name" autocomplete="family-name" class="auth-input"
                                    v-model="clientDetails.lastName" @blur="$v.clientDetails.lastName.$touch()" :state="validateState('lastName')"
                                    :aria-describedby="errorIdIf('signup-last-name', $v.clientDetails.lastName.$error)"
                                    data-testid="signup-last-name-input" />
                                <b-form-invalid-feedback id="signup-last-name-error">Last name is required</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <template v-if="authProvider !== 'GOOGLE'">
                            <b-form-group label="Email" label-for="signup-email" class="auth-field"
                                :description="isInvited ? 'Use the same email address your invite was sent to.' : null">
                                <b-form-input id="signup-email" type="email" autocomplete="email" class="auth-input"
                                    v-model="clientDetails.email" @blur="$v.clientDetails.email.$touch()" :state="validateState('email')"
                                    :disabled="emailDisabled" :aria-describedby="errorIdIf('signup-email', $v.clientDetails.email.$error)"
                                    data-testid="signup-email-input" />
                                <b-form-invalid-feedback id="signup-email-error" v-if="!$v.clientDetails.email.required">Email is required</b-form-invalid-feedback>
                                <b-form-invalid-feedback id="signup-email-error" v-if="!$v.clientDetails.email.email">This must be a valid email address.</b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group label="Create a password" label-for="signup-password" class="auth-field">
                                <div class="auth-password">
                                    <b-form-input id="signup-password" :type="showPassword ? 'text' : 'password'" autocomplete="new-password"
                                        class="auth-input" v-model="clientDetails.password" @blur="$v.clientDetails.password.$touch()" :state="validateState('password')"
                                        :aria-describedby="$v.clientDetails.password.$error ? 'signup-password-error' : 'signup-password-hint'"
                                        data-testid="signup-password-input" />
                                    <button type="button" class="auth-show-btn" @click="showPassword = !showPassword">{{ showPassword ? 'Hide' : 'Show' }}</button>
                                </div>
                                <div id="signup-password-error" v-if="!$v.clientDetails.password.required && $v.clientDetails.password.$error" class="invalid-feedback d-block">Password is required</div>
                                <div id="signup-password-error" v-else-if="!$v.clientDetails.password.minLength && $v.clientDetails.password.$error" class="invalid-feedback d-block">Password must be at least 6 characters</div>
                                <small v-else id="signup-password-hint" class="auth-optional">At least 6 characters</small>
                            </b-form-group>
                        </template>
                        <b-form-group v-if="currentRole !== 'party'" label-for="signup-org" class="auth-field">
                            <template #label>Firm or organization <span class="auth-optional">(optional)</span></template>
                            <b-form-input id="signup-org" autocomplete="organization" class="auth-input"
                                v-model="clientDetails.organizationName" data-testid="signup-org-name-input" />
                        </b-form-group>
                        <b-form-group label-for="signup-province" class="auth-field"
                            :class="{ 'auth-field-wide': currentRole === 'party' }">
                            <template #label>
                                <template v-if="currentRole === 'party'">Province <span class="auth-optional">(optional)</span></template>
                                <template v-else>Province of practice</template>
                            </template>
                            <b-form-select id="signup-province" class="auth-input" :options="Provinces" text-field="name" value-field="name"
                                v-model="$v.clientDetails.locationOfPractice.$model"
                                :state="currentRole !== 'party' ? validateState('locationOfPractice') : null"
                                :aria-describedby="errorIdIf('signup-province', $v.clientDetails.locationOfPractice.$error)"
                                data-testid="signup-province-input">
                                <template #first>
                                    <b-form-select-option value="">Choose a province</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-form-invalid-feedback id="signup-province-error">Province is required</b-form-invalid-feedback>
                        </b-form-group>
                        <div class="auth-terms">
                            <b-form-checkbox v-model="$v.clientDetails.termsOfService.$model" :state="validateState('termsOfService')"
                                name="terms" class="auth-check" :aria-describedby="errorIdIf('signup-terms', $v.clientDetails.termsOfService.$error)"
                                data-testid="signup-terms-input">
                                I agree to the {{ termsName }}
                            </b-form-checkbox>
                            <a :href="termsUrl" target="_blank" rel="noopener" class="auth-terms-link">Read the {{ termsName }}</a>
                        </div>
                        <div id="signup-terms-error" v-if="$v.clientDetails.termsOfService.$error" class="invalid-feedback d-block">
                            You must accept the terms to continue
                        </div>
                        <b-form-checkbox v-if="showMarketingConsent" v-model="clientDetails.marketingConsent" name="marketing-consent"
                            class="auth-check auth-check-muted" data-testid="signup-marketing-consent-input">
                            Email me product tips and occasional offers <span class="auth-optional">(optional)</span>
                        </b-form-checkbox>
                        <b-button type="submit" block class="auth-primary-btn" :disabled="signUpLoading"
                            data-testid="create-account">
                            <template v-if="signUpLoading"><b-spinner small /> Creating your account…</template>
                            <span v-else>{{ signupButtonLabel }}</span>
                        </b-button>
                        <p v-if="signUpLoading" class="auth-hint" role="status">This can take up to 20 seconds. Please keep this page open.</p>
                        <p v-else-if="signupNextStep" class="auth-hint">{{ signupNextStep }}</p>
                        <div v-if="emailInUse" class="auth-alert auth-alert-error" data-testid="signup-email-in-use">
                            This email already has a Divii account.
                            <a href="#" @click.prevent="goToLogin(false)">Log in</a> or
                            <a href="#" @click.prevent="goToLogin(true)">reset your password</a>.
                        </div>
                    </form>
                </div>

                <div v-else key="signup-choose" data-testid="signup-1">
                    <template v-if="isInvited">
                        <span class="auth-badge">Nothing to pay</span>
                        <h1 class="auth-title">You've been invited</h1>
                        <p class="auth-subtitle">Someone shared a separation agreement with you on Divii. Set up your access to open it.</p>
                    </template>
                    <template v-else-if="userType === 'lawyer'">
                        <h1 class="auth-title">Create your lawyer account</h1>
                        <p class="auth-subtitle">Use Clio to bring your matters across, or sign up with Google or email.</p>
                    </template>
                    <template v-else>
                        <h1 class="auth-title d-lg-none">Your separation agreement, written as you answer.</h1>
                        <h1 class="auth-title d-none d-lg-block">Create your account</h1>
                        <p class="auth-price-line d-lg-none"><b>From $895</b> one time · your spouse joins free</p>
                        <p class="auth-subtitle d-lg-none">Create an account to start. Your answers stay private until you invite someone.</p>
                        <p class="auth-subtitle d-none d-lg-block">An account keeps your personal information private. Only you can see it until you invite someone.</p>
                    </template>
                    <div class="auth-providers">
                        <button v-if="currentRole !== 'party'" type="button" class="auth-provider-btn auth-provider-clio"
                            @click="signUpWithClio" data-testid="clio-signup-btn">
                            <img src="@/assets/clioLogo.svg" alt="" /> Sign up with Clio
                        </button>
                        <button type="button" class="auth-provider-btn" @click="signUpWithGoogle" data-testid="google-signup">
                            <img src="@/assets/googleLogo.svg" alt="" /> Continue with Google
                        </button>
                        <button type="button" class="auth-provider-btn" @click="signUpWithEmail" data-testid="email-signup">
                            <b-icon-envelope /> Continue with email
                        </button>
                    </div>
                    <div v-if="signupError" class="auth-alert auth-alert-error">{{ signupError }}</div>
                    <div v-if="isInvited" class="auth-note">
                        Use the same email address your invite was sent to, so we can link you to the agreement.
                    </div>
                    <p class="auth-footnote">Already have an account? <a href="#" @click.prevent="changeTab($event, 0)">Log in</a></p>
                </div>
            </template>
            </fieldset>
        </section>

        <aside v-if="showSignupIntro || showLoginIntro" class="auth-intro">
            <template v-if="showLoginIntro && userType === 'lawyer'">
                <span class="auth-eyebrow">Divii for Lawyers</span>
                <h2 class="auth-intro-title">Welcome back.</h2>
                <p class="auth-intro-text">Your files, clients and agreements are where you left them.</p>
            </template>
            <template v-else-if="userType === 'lawyer'">
                <span class="auth-eyebrow">For Canadian family lawyers</span>
                <h2 class="auth-intro-title">Draft separation agreements with your clients, in one shared file.</h2>
                <ul class="auth-points">
                    <li>Bring in matters from Clio</li>
                    <li>Child and spousal support calculators built in</li>
                    <li>Share a file with your client to collect their answers</li>
                    <li>Export the agreement to Word</li>
                </ul>
                <p class="auth-intro-note">For practising Canadian lawyers. Every account is verified.</p>
            </template>
            <template v-else>
                <template v-if="showLoginIntro">
                    <h2 class="auth-intro-title">Welcome back.</h2>
                    <p class="auth-intro-text">Your agreement is saved exactly where you left it.</p>
                </template>
                <template v-else>
                    <h2 class="auth-intro-title d-lg-none">How it works</h2>
                    <h2 class="auth-intro-title d-none d-lg-block">Your separation agreement, written as you answer.</h2>
                    <p class="auth-intro-text">
                        Plain questions about parenting, support and property. Divii turns your answers into a complete agreement
                        you can work on alone or with your spouse.
                    </p>
                </template>
                <div class="auth-intro-grid">
                    <div v-if="!showLoginIntro" class="auth-intro-col">
                        <ul class="auth-points">
                            <li>Guided questions, one topic at a time</li>
                            <li>Child and spousal support calculators built in</li>
                            <li>Invite your spouse to the same file</li>
                            <li>Private until you choose to share it</li>
                        </ul>
                        <div class="auth-price">
                            <span class="auth-price-amount">From $895</span> <span>one time</span>
                            <p>Your spouse joins free. Plus tax. No subscription.</p>
                        </div>
                    </div>
                    <div class="auth-covers">
                        <span class="auth-eyebrow">What your agreement covers</span>
                        <ol>
                            <li><b>Basics</b><span>You, your spouse and your relationship</span></li>
                            <li><b>Parenting</b><span>Decision-making and parenting time</span></li>
                            <li><b>Child Support</b><span>Guideline amounts, worked out for you</span></li>
                            <li><b>Spousal Support</b><span>Amount and how long it lasts</span></li>
                            <li><b>Property</b><span>Home, pensions, savings and debts</span></li>
                            <li><b>Final Clauses</b><span>Legal advice and signing</span></li>
                        </ol>
                        <div class="auth-covers-built">
                            <span class="auth-covers-label">Built in</span>
                            <span class="auth-chip">Parenting schedule</span>
                            <span class="auth-chip">Support calculator</span>
                            <span class="auth-chip">Pension calculator</span>
                        </div>
                    </div>
                </div>
                <fieldset v-if="!showLoginIntro" class="auth-fieldset auth-intro-cta d-lg-none" :disabled="formBusy" :aria-busy="formBusy">
                    <h2 class="auth-intro-title">Start your agreement</h2>
                    <button type="button" class="auth-provider-btn" @click="signUpWithGoogle" data-testid="google-signup-bottom">
                        <img src="@/assets/googleLogo.svg" alt="" /> Continue with Google
                    </button>
                    <button type="button" class="auth-provider-btn" @click="signUpWithEmail" data-testid="email-signup-bottom">
                        <b-icon-envelope /> Continue with email
                    </button>
                    <div v-if="signupError" class="auth-alert auth-alert-error">{{ signupError }}</div>
                    <p class="auth-footnote">Already have an account? <a href="#" @click.prevent="changeTab($event, 0)">Log in</a></p>
                </fieldset>
            </template>
        </aside>
    </div>
</template>

<style>

.zoom-in-enter-active{
	-webkit-animation: zoom-in-enter-active 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
	animation: zoom-in-enter-active 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
.custom-checkbox .b-form-checkbox:checked {
    background-color: #3d7190 !important;
    border-color: #3d7190 !important;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    color: white;
}

.custom-checkbox .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem rgba(52, 144, 220, 0.25);
}

@-webkit-keyframes zoom-in-enter-active {
  0% {
    -webkit-transform: scale(0.8);
            transform: scale(0.8);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}
@keyframes zoom-in-enter-active {
  0% {
    -webkit-transform: scale(0.8);
            transform: scale(0.8);
  }
  100% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

.nav-link.active {
  opacity: 1 !important;
  transition: .7s ease-out !important;
}


.signup-input-margin{
    margin-bottom: 1.56rem !important;
}

.login-input-margin{
    margin-bottom: 1.8rem !important;
}

/* .zoom-in-enter-active {
    transition: all 0.6s ease;
    opacity: 1;

} */

.slide-fade-enter-active {
    transition: all 0.6s ease;
    opacity: 1;

}

.slide-fade-enter, .slide-fade-leave-active {
    position: absolute;
    opacity: 0;
}

.slide-fade-enter {
    transform: translateX(20%);
    opacity: 0;
}

.home-container {
    position: relative;
    border: 3px solid #c9dce1;
    border-radius: 8px;
    min-height: 85vh;
    margin-bottom: 1.5rem;
    /* width: 50vw; */
}

.login-heading {
    font-weight: 700;
    font-size: 30px;
}

.login-desc {
    font-size: 20px;
    font-weight: 400;
}

.signup-text-1 {
    font-size: 20px;
    font-weight: 500;
}

.signup-text-2 {
    font-size: 17px;
    font-weight: 500;
}

.signup-text-3 {
    font-size: 15px;
    font-weight: 495;
}

.signup-text-4 {
    font-size: 15px;
    font-weight: 495;
}

.login-tabs .nav-link {
    border-radius: 20px !important;
}

.login-tabs .nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    background-color: #3F6772 !important;
}

.login-tabs ul {
    border-radius: 22px !important;
    border: 2px solid #3F6772;
}

.terms-text {
    color: black;
}

.page-dot-active {
    color: #3F6772;
    font-size: 1.5rem;
}

.page-dot {
    color: #c9dce1;
    font-size: 1.5rem;
}

.page-dot-disabled {
    color: grey;
    font-size: 1.5rem;
    cursor:default ;
}

.login-signup-form {
    display: grid;
}

.pagination-dots {
    /* margin-top: 15px; */
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;
    align-self: end;
    pointer-events: none;
}
.pagination-dots .clickable {
    pointer-events: auto;
}

.signup-text-5 {
    font-size: 18px;
    font-weight: 500;
    color: #3F6772;
}

.signup-input {
    border-radius: 10px;
}

.empty-div {
    height: 217px;
}

/* .page-slide {
    height: 453px;
} */

.form-group legend {
    padding-bottom: calc(0.1rem + 1px);
}

/*.active-role {
    filter: drop-shadow(0px 0px 25px #3d7190);
    zoom: 105%;
}

.active-role-name {
    font-weight: bold;
    color: #3F6772;
    font-size: large;
}*/

.was-validated .form-control:invalid,
.form-control.is-invalid {
    border-color: #dc3545 !important;
}

.invalid-feedback {
    color: #dc3545;
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
    -webkit-box-shadow: 0 0 0 0.2rem rgba(218, 71, 78, 0.25);
    box-shadow: 0 0 0 0.2rem rgba(218, 71, 78, 0.25);
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" stroke="%23dc3545" viewBox="0 0 12 12"><circle cx="6" cy="6" r="4.5"/><path stroke-linejoin="round" d="M5.8 3.6h.4L6 6.5z"/><circle cx="6" cy="8.2" r=".6" fill="%23dc3545" stroke="none"/></svg>') !important;
}

.signup-input {
    /* height: calc(1.5em + 0.75rem + 2px); */
    height: calc(1.2em + 0.75rem + 2px)
}

/* .signup-input.is-invalid {
    height: calc(1.2em + 0.75rem + 2px) !important;
} */

.login-input {
    border-radius: 10px;
    /* height: calc(2em + 0.75rem + 2px); */
    height: calc(1.5em + 0.75rem + 2px) !important;
}

/* .login-input.is-invalid {
    height: calc(1.5em + 0.75rem + 2px);
} */

/* .login-page-btn-blue {
    background-color: #3d7190;
    border-color: #3d7190 !important;
} */

.forot-password-desc-2 {
    font-weight: 300;
    font-size: 15px;
}

.space-filler {
    height: 93px;
}

.empty-button {
    height: 44.55px;
}

.success-msg{
	padding-top: 10px;
	color: green;
}
.error-msg{
	padding-top: 10px;
	color: #dc3545;
}
@media (max-width: 576px) {
    .home-container {
        /* height: 87vh; */
        height: 100%;
    }

    .role-img {
        width: 70px;
    }

    .space-filler {
        height: 150px !important;
    }
    .create-account-text {
        font-size: 1.1rem !important;
    }
    .page-slide {
        height: 70vh !important;
        display: grid;
    }
    .forgot-password-form{
        display: grid;
        align-items: center !important;
    }
    .page-slide-2 {
        height: 100% !important;
    }
    .form-password{
        padding-right:0;
    }
    .update-user-btn-text{
        font-size: 0.8rem !important;
    }
}
.page-slide {
    height: 67vh !important;
    display: grid;
}

.page-slide-arrange{
    grid-template-rows: 2rem auto 3rem;
}
.page-slide-arrange-login{
    grid-template-rows: 4rem 10rem auto 3rem;
}
.page-slide-2 {
    min-height: 66vh;
    display: grid;
}
.clio-checkbox>label{
    cursor: pointer !important;
}

.show-password-btn{
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.update-user-btn-text{
    font-size: 1rem;
}
.update-user-btn{
    width: auto !important;
    max-width: none !important;
    flex: 0 0 auto !important;
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}

.tab-content >.active{
   background-color: #fff ; 
}

.input-required legend::after{
    content: " *" !important;
    color: red !important;
}

.auth-provider-btn{
    border: 1px solid #000;
}
.auth-provider-btn:hover{
    cursor: pointer;
    border: 1px solid #000;
    font-weight: bold;
}

.role-img:hover{
    scale: 1.1;
}
.role-img:hover + p{
    font-weight: bold;
}
.role-ht{
    max-height:30% ;
}
</style>
<style scoped>
.auth-page {
    display: grid;
    grid-template-columns: minmax(0, 480px);
    justify-content: center;
    gap: 0;
    padding: 32px 16px 48px;
    font-family: Roboto, 'Helvetica Neue', Arial, sans-serif;
    color: #243B42;
}
.auth-page-split {
    grid-template-columns: minmax(0, 480px);
    padding-bottom: 0;
}
body.is-edge .auth-page {
    height: calc(100vh - 74px);
    min-height: 0;
    overflow-y: auto;
}
.auth-card {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    padding: 28px 24px;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(36, 59, 66, 0.08);
}
.auth-fieldset {
    display: flex;
    flex-direction: column;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
}
.auth-fieldset:disabled a {
    pointer-events: none;
    opacity: 0.6;
}
.auth-fieldset:disabled .auth-provider-btn,
.auth-fieldset:disabled .auth-back {
    opacity: 0.6;
    cursor: not-allowed;
}
.auth-fieldset > div,
.auth-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}
.auth-title {
    margin: 4px 0 0;
    font-size: 28px;
    line-height: 1.15;
    font-weight: 900;
    color: #243B42;
}
.auth-subtitle {
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
    color: #3F6772;
}
.auth-steps {
    display: grid;
    gap: 8px;
    margin: 0 0 18px;
    padding: 0;
    list-style: none;
}
.auth-steps li {
    padding-top: 9px;
    border-top: 4px solid #E3EAEC;
    font-size: 14px;
    color: #3F6772;
}
.auth-steps li.auth-step-done {
    border-top-color: #3F6772;
}
.auth-steps li.auth-step-current {
    font-weight: 700;
    color: #243B42;
}
.auth-back {
    align-self: flex-start;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 0;
    border: 0;
    background: none;
    font-size: 15px;
    font-weight: 500;
    color: #266076;
}
.auth-providers {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 6px;
}
.auth-provider-btn {
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    border: 1.5px solid #9CB6BD;
    border-radius: 10px;
    background: #ffffff;
    font-size: 16px;
    font-weight: 500;
    color: #243B42;
}
.auth-provider-btn:hover {
    border-color: #3F6772;
    background: #F4F7F8;
}
.auth-provider-btn img {
    height: 20px;
    width: auto;
}
.auth-provider-clio {
    border-color: #F7A91B;
    background: #F7A91B;
    font-weight: 700;
}
.auth-provider-clio:hover {
    border-color: #E89A0C;
    background: #E89A0C;
}
.auth-primary-btn,
.auth-primary-btn:disabled {
    height: 54px;
    margin-top: 6px;
    border: 0;
    border-radius: 10px;
    background: #F7A91B;
    font-size: 17px;
    font-weight: 700;
    color: #243B42;
}
.auth-primary-btn:hover,
.auth-primary-btn:focus {
    background: #E89A0C;
    color: #243B42;
}
.auth-hint {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #5C7A82;
}
.auth-footnote {
    margin: 4px 0 0;
    font-size: 14px;
    color: #3F6772;
}
.auth-footnote a,
.auth-forgot a,
.auth-terms-link {
    font-weight: 500;
    color: #266076;
    text-decoration: underline;
}
.auth-note {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 14px 16px;
    border-radius: 12px;
    background: #EEF3F4;
    font-size: 14px;
    line-height: 1.5;
    color: #3F6772;
}
.auth-alert {
    padding: 12px 14px;
    border-radius: 10px;
    font-size: 14px;
    line-height: 1.5;
}
.auth-alert-error {
    border: 1.5px solid #F2B8B5;
    background: #FDF1F0;
    color: #8C1D18;
}
.auth-alert-success {
    border: 1.5px solid #B7DCC4;
    background: #EEF8F1;
    color: #1E5631;
}
.auth-badge {
    align-self: flex-start;
    padding: 4px 10px;
    border-radius: 8px;
    background: #FDEFD3;
    font-size: 13px;
    font-weight: 700;
}
.auth-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}
.auth-field {
    margin: 0;
}
.auth-field >>> label,
.auth-field >>> legend {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    padding-bottom: 6px;
    font-size: 14px;
    font-weight: 500;
    color: #243B42;
}
.auth-optional {
    font-size: 13px;
    font-weight: 400;
    color: #5C7A82;
}
.auth-input {
    height: 48px;
    border: 1.5px solid #C5D4D8;
    border-radius: 10px;
    font-size: 16px;
}
.auth-input:focus {
    border-color: #3F6772;
    box-shadow: 0 0 0 3px rgba(63, 103, 114, 0.18);
}
.auth-password {
    position: relative;
}
.auth-password .auth-input {
    padding-right: 64px;
    background-image: none !important;
}
.auth-show-btn {
    position: absolute;
    top: 0;
    right: 4px;
    height: 48px;
    padding: 0 12px;
    border: 0;
    background: none;
    font-size: 14px;
    font-weight: 500;
    color: #266076;
}
.auth-forgot {
    margin-top: -6px;
    text-align: right;
    font-size: 14px;
}
.auth-check {
    display: flex;
    align-items: center;
    min-height: 44px;
    font-size: 14px;
    line-height: 1.45;
    color: #243B42;
}
.auth-check >>> .custom-control-label {
    padding-top: 2px;
    cursor: pointer;
}
.auth-check >>> .custom-control-input.is-invalid ~ .custom-control-label,
.auth-check >>> .custom-control-input.is-valid ~ .custom-control-label {
    color: #243B42;
}
.auth-check >>> .custom-control-input.is-invalid ~ .custom-control-label::before {
    border-color: #dc3545;
}
.auth-terms {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 16px;
}
.auth-terms-link {
    font-size: 14px;
}
.auth-check-muted {
    color: #3F6772;
}
.auth-google-account {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    border: 1.5px solid #E3EAEC;
    border-radius: 12px;
}
.auth-avatar {
    flex: 0 0 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    background: #3F6772;
    font-weight: 700;
    color: #ffffff;
}
.auth-google-name {
    display: flex;
    flex-direction: column;
    min-width: 0;
    font-size: 15px;
}
.auth-google-name span {
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #3F6772;
}
.auth-intro {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 32px 0 0;
    padding: 28px 0 40px;
    background: #EEF3F4;
    box-shadow: 0 0 0 100vmax #EEF3F4;
    clip-path: inset(0 -100vmax -100vmax);
}
.auth-eyebrow {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #3F6772;
}
.auth-intro-title {
    margin: 0;
    font-size: 26px;
    line-height: 1.15;
    font-weight: 900;
    color: #243B42;
}
.auth-intro-text {
    margin: 0;
    font-size: 16px;
    line-height: 1.55;
    color: #3F6772;
}
.auth-intro-note {
    margin: 0;
    font-size: 14px;
    color: #3F6772;
}
.auth-intro-cta {
    gap: 12px;
    padding-top: 8px;
}
.auth-price-line {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    color: #3F6772;
}
.auth-price-line b {
    font-weight: 900;
    color: #243B42;
    white-space: nowrap;
}
.auth-intro-grid,
.auth-intro-col {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.auth-points {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style: none;
}
.auth-points li {
    position: relative;
    padding-left: 34px;
    font-size: 16px;
    line-height: 1.45;
}
.auth-points li::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 22px;
    height: 22px;
    border: 2px solid #266076;
    border-radius: 50%;
    box-sizing: border-box;
}
.auth-points li::after {
    content: '';
    position: absolute;
    left: 7px;
    top: 5px;
    width: 8px;
    height: 11px;
    border: solid #266076;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}
.auth-price {
    padding: 18px 20px;
    border: 1px solid #DCE5E8;
    border-radius: 14px;
    background: #ffffff;
    font-size: 15px;
    color: #3F6772;
}
.auth-price-amount {
    font-size: 30px;
    font-weight: 900;
    color: #243B42;
}
.auth-price p {
    margin: 4px 0 0;
    font-size: 14px;
}
.auth-covers {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 20px;
    border-radius: 16px;
    background: #ffffff;
    box-shadow: 0 12px 32px rgba(36, 59, 66, 0.12);
}
.auth-covers ol {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 0;
    padding: 0;
    list-style: none;
    counter-reset: section;
}
.auth-covers li {
    position: relative;
    display: flex;
    flex-direction: column;
    padding-left: 38px;
    counter-increment: section;
    font-size: 15px;
}
.auth-covers li::before {
    content: counter(section);
    position: absolute;
    left: 0;
    top: 0;
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13px;
    background: #E6F0F2;
    font-size: 13px;
    font-weight: 700;
    color: #266076;
}
.auth-covers li b {
    font-weight: 500;
}
.auth-covers li span {
    font-size: 13px;
    color: #5C7A82;
}
.auth-covers-built {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding-top: 12px;
    border-top: 1px solid #E3EAEC;
}
.auth-covers-label {
    margin-right: 4px;
    font-size: 13px;
    color: #3F6772;
}
.auth-chip {
    padding: 4px 10px;
    border-radius: 14px;
    background: #FDEFD3;
    font-size: 13px;
    font-weight: 500;
}

.auth-page-lawyer .auth-intro {
    background: #243B42;
    box-shadow: 0 0 0 100vmax #243B42;
    color: #ffffff;
}
.auth-page-lawyer .auth-eyebrow {
    color: #F7A91B;
}
.auth-page-lawyer .auth-intro-title {
    color: #ffffff;
}
.auth-page-lawyer .auth-intro-text,
.auth-page-lawyer .auth-intro-note {
    color: #C9D8DC;
}
.auth-page-lawyer .auth-points li::before,
.auth-page-lawyer .auth-points li::after {
    border-color: #7ED6D6;
}
.auth-page-login-intro .auth-intro {
    display: none;
}

@media (max-width: 767.98px) {
    .auth-card {
        padding: 4px 0 0;
        border-radius: 0;
        box-shadow: none;
    }
}

@media (max-width: 767.98px), (max-height: 500px) {
    .auth-title {
        font-size: 24px;
    }
    .auth-subtitle,
    .auth-back,
    .auth-google-name {
        font-size: 14px;
    }
    .auth-steps li {
        font-size: 13px;
    }
    .auth-provider-btn {
        height: 48px;
        font-size: 15px;
    }
    .auth-primary-btn,
    .auth-primary-btn:disabled {
        height: 48px;
        font-size: 16px;
    }
    .auth-intro-title {
        font-size: 22px;
    }
    .auth-intro-text,
    .auth-points li {
        font-size: 15px;
    }
    .auth-price-amount {
        font-size: 26px;
    }
    .auth-covers li {
        font-size: 14px;
    }
}

@media (max-width: 991.98px), (max-height: 500px) {
    .auth-footnote {
        margin: 0;
        font-size: 15px;
    }
    .auth-footnote a {
        display: inline-flex;
        align-items: center;
        min-height: 48px;
        padding: 0 4px;
        font-size: 16px;
    }
}

@media (min-width: 768px) {
    .auth-page {
        align-content: start;
        min-height: calc(100vh - 72px);
        padding: 32px;
        background: #EEF3F4;
    }
    .auth-page-form {
        grid-template-columns: minmax(0, 680px);
    }
    .auth-page-form .auth-card {
        padding: 28px 40px 32px;
    }
    .auth-page-form .auth-form {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px 20px;
    }
    .auth-page-form .auth-row {
        display: contents;
    }
    .auth-page-form .auth-form > :not(.auth-field):not(.auth-row),
    .auth-field-wide {
        grid-column: 1 / -1;
    }
    .auth-page-form .auth-hint {
        text-align: center;
    }
    .auth-page-split {
        padding-bottom: 0;
        background: #ffffff;
    }
}

@media (min-width: 992px) {
    .auth-page-login-intro .auth-intro {
        display: flex;
    }
    .auth-page-split.auth-page-lawyer .auth-intro {
        box-shadow: 0 0 0 100vmax #243B42;
    }
    .auth-page-split {
        align-content: stretch;
        background: #ffffff;
        grid-template-columns: minmax(0, 7fr) minmax(0, 5fr);
        justify-content: stretch;
        padding: 0 max(32px, calc((100% - 1240px) / 2));
        min-height: calc(100vh - 72px);
        overflow: hidden;
    }
    .auth-page-split .auth-card {
        order: 2;
        justify-content: center;
        padding: 40px 0 40px 64px;
        border-radius: 0;
        box-shadow: none;
        background: none;
    }
    .auth-page-split .auth-intro {
        order: 1;
        justify-content: center;
        margin: 0;
        padding: 40px 64px 40px 0;
        box-shadow: 0 0 0 100vmax #EEF3F4;
        clip-path: inset(0 0 -100vmax -100vmax);
    }
    .auth-intro-title {
        font-size: 36px;
    }
    .auth-page-login-intro.auth-page-lawyer .auth-eyebrow {
        margin-bottom: 4px;
        font-size: 14px;
    }
    .auth-page-login-intro.auth-page-lawyer .auth-intro-title {
        font-size: 52px;
    }
    .auth-page-login-intro.auth-page-lawyer .auth-intro-text {
        font-size: 20px;
    }
    .auth-intro-col {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 250px);
        align-items: center;
        gap: 24px;
    }
    .auth-price-amount {
        font-size: 24px;
        white-space: nowrap;
    }
    .auth-covers ol {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px 24px;
    }
}
</style>
